<template>
  <div>
    <vue-element-loading
      :active="appLoading"
      spinner="bar-fade-scale"
      color="#1976d2"
       size="50"
      is-full-screen
    />
    <v-layout v-if="ServerError" wrap justify-center>
      <v-flex px-5 pt-5 xs12 sm12 md12 lg12 xl12 text-center>
        <ServerError />
      </v-flex>
    </v-layout>
    <v-snackbar v-model="showsnackbar" color="#9eaade" right :timeout="timeout">
      <v-layout wrap justify-center>
        <v-flex text-left class="align-self-center">{{ msg }}</v-flex>
        <v-flex text-right>
          <v-btn small :ripple="false" text @click="showsnackbar = false">
            <v-icon style="color: white">mdi-close</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-snackbar>
    <v-layout justify-center wrap>
      <v-flex xs12 pt-5>
        <v-card>
          <v-layout justify-start wrap pt-6>
            <v-layout justify-center wrap>
              <v-flex xs3 sm3 md3 pl-5 text-center>
               <v-img width="30px" src="./../../assets/images/class.svg"></v-img>
              </v-flex>
              <v-flex xs9 sm9 md9 text-left>
                <span
                  style="
                    font-family: nunitosansbold;
                    font-size: 20px;
                    color: #000000;"
                  >Add Class</span>
              </v-flex>
            </v-layout>
            <v-flex xs6 sm6 md9>
              <router-link :to="'/addClass'" style="text-decoration: none">
                <span
                  style="
                    color: #797979;
                    font-family: nunitosanssemibold;
                    font-size: 18px;"
                  >View Class</span>
              </router-link>
            </v-flex></v-layout>
          <v-card-text>
            <v-layout justify-center wrap>
              <v-flex xs12 sm6 md6 pa-2>
                <v-select
                  v-model="standard"
                  dense
                  style="font-family: nunitosanssemibold"
                  outlined
                  label="Class"
                  :items="standardArray"
                  item-text="standardName"
                  item-value="_id"
                ></v-select>
              </v-flex>
              <v-flex xs12 sm6 md6 pa-2>
                <v-text-field
                  v-model="classAdd.division"
                  @keyup="uppercase"
                  label="Section"
                  dense
                  style="font-family: nunitosansregular"
                  outlined
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md6 pa-2>
                <v-select
                  v-model="classAdd.classTeacher"
                  dense
                  style="font-family: nunitosansregular"
                  outlined
                  label="Assign Class Teacher"
                  :items="teacher"
                  item-text="user.name"
                  item-value="_id"
                ></v-select>
              </v-flex>
              <v-flex xs12 sm6 md6 pa-2>
                <v-select
                  v-model="classAdd.classTeacherSubject"
                  dense
                  style="font-family: nunitosansregular"
                  outlined
                  label="Subject"
                  :items="subject"
                  item-text="subjectName"
                  item-value="_id"
                ></v-select>
              </v-flex>
              <v-flex xs12 sm6 md4 pb-8>
                <v-btn
                  @click="validateInput"
                  dark
                  block
                  height="50px"
                  style="font-family: nunitosanssemibold"
                  color="#9B8DFD"
                  >ADD CLASS</v-btn>
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-layout justify-center wrap>
            <v-flex xs12>
              <v-layout justify-center wrap>
                <v-layout justify-center wrap>
                  <v-flex xs12 class="dottedline"> </v-flex>
                </v-layout>
                <v-flex xs1>
                  <p class="text-center">or</p>
                </v-flex>
                <v-layout justify-center wrap>
                  <v-flex xs12 class="dottedline"> </v-flex>
                </v-layout>
              </v-layout>
            </v-flex>
          </v-layout>
          <v-card-text>
            <v-layout justify-center wrap>
              <v-flex xs12 text-center v-if="file">
                 <span>{{file.name}}</span>
              </v-flex>
              <v-flex xs12 md4 offset-md4>
                <v-btn
                  block
                  small
                  dark
                  height="50px"
                  color="#9B8DFD"
                  @click="$refs.showFile.click()">
                  <v-icon style="color: #ffffff">mdi-note-text-outline</v-icon>
                  <span style="font-family: nunitosanssemibold"
                    >UPLOAD CLASS INFO SHEET</span>
                </v-btn>
                <input
                  v-show="false"
                  id="file"
                  ref="showFile"
                  multiple="multiple"
                  type="file"
                  @change="showFile"
                />
                <v-layout justify-center wrap pt-2>
                  <v-flex xs12 text-center>
                    <span style="font-family: nunitosansregular; color: #8f8f8f"
                      >Upload One or Multiple Class Data</span
                    >
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex xs12 sm12 md4 py-2 text-right>
                <a
                  :href="'http://52.66.213.94/u/1625479647296.xlsx'"
                  style="text-decoration: none"
                >
                  <v-btn small plain color="#9B8DFD">
                    <span>Download Template</span>
                    <v-icon>mdi-download-outline</v-icon>
                  </v-btn>
                </a>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
import axios from "axios";
export default {
  data() {
    return {
      hover: false,
      appLoading: false,
      showsnackbar: false,
      ServerError: false,
      msg: "",
      timeout: 5000,
      filePreview: false,
      showFilePreview: false,
      file: null,
      sub: {
        subjectid: "",
        teacherid: "",
      },
      standard: "",
      classAdd: {
        division: "",
        classTeacher: "",
        classTeacherSubject: "",
      },
      studentList: [],
      page: 1,
      classArray: [],
      classid: "",
      standardArray: [],
      section: [],
      teacher: [],
      subject: [],
      user: [],
      group: [],
    };
  },
  watch: {
    standard() {
      this.getSubject();
    },
  },
  mounted() {
    this.getStandard();
    this.getSection();
    this.getTeacher();
    this.getSubject();
    this.getData();
    this.getGroupTeacher();
  },
  methods: {
    uppercase() {
      this.classAdd.division = this.classAdd.division.toUpperCase();
    },
    validateInput() {
      if (!this.standard) {
        this.msg = "Please Provide Class";
        this.showsnackbar = true;
        return;
      } else if (!this.classAdd.division) {
        this.msg = "Please Provide Section";
        this.showsnackbar = true;
        return;
      } else if (this.classAdd.division <= 1) {
        this.msg = "Please Provide Section";
        this.showsnackbar = true;
        return;
      } else if (!this.classAdd.classTeacher) {
        this.msg = "Please Provide Teacher";
        this.showsnackbarr = true;
        return;
      } else if (!this.classAdd.classTeacherSubject) {
        this.msg = "Please Provide Subject";
        this.showsnackbar = true;
        return;
      } else {
        this.addClass();
      }
    },
    validate() {
      if (!this.sub.subjectid) {
        this.msg = "Please Provide Subject";
        this.showsnackbar = true;
        return;
      } else if (!this.sub.teacherid) {
        this.msg = "Please Provide Teacher";
        this.showsnackbar = true;
        return;
      } else {
        this.addSubject(this.classid);
      }
    },
    showFile(e) {
      this.file = e.target.files[0];
      var reader = new FileReader();
      reader.onload = (e) => {
        this.filePreview = e.target.result;
      };
      if (this.file.size > 2145728) {
        this.msg = "File Should be less than 2MB";
        this.showsnackbar = true;
        return;
      }
      this.showFilePreview = true;
      if (this.file) {
        if (/\.(jpe?g|png|gif)$/i.test(this.file.name)) {
          reader.readAsDataURL(this.file);
        }
        this.uploadFile()
      }
    },
    uploadFile() {
      let formData = new FormData();
      formData.append("doc", this.file);
      axios({
        method: "POST",
        url: "/excelimport/class/upload",
        data: formData,
        headers: {
          "Content-Type": "multipart/form-data",
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status == true) {
            this.msg = "Uploaded Successully";
            this.showsnackbar = true;
            this.file=null;
            this.getData();
          } else {
            this.msg = response.data.msg;
            this.showsnackbar = true;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          console.log(err);
        });
    },
    getGroupTeacher() {
      this.appLoading = true;
      axios({
        method: "GET",
        url: "/teacher/getlistgrouped",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          this.group = response.data.data;
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    getData(id) {
      this.appLoading = true;
      axios({
        method: "GET",
        url: "/teacher/getlist",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        params: {
          classid: id,
        },
      })
        .then((response) => {
          this.appLoading = false;
          this.user = response.data.data;
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    getSubject() {
      this.appLoading = true;
      axios({
        method: "GET",
        url: "/standard/subject/getlist",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        params: {
          standard: this.standard,
        },
      })
        .then((response) => {
          this.appLoading = false;
          this.subject = response.data.data;
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    getStandard() {
      this.appLoading = true;
      axios({
        method: "GET",
        url: "/standard/getlist",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          this.standardArray = response.data.data;
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    getSection() {
      this.appLoading = true;
      axios({
        method: "GET",
        url: "/division/getlist",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          this.section = response.data.data;
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    getTeacher() {
      this.appLoading = true;
      axios({
        method: "GET",
        url: "/teacher/getlist",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          this.teacher = response.data.data;
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    addClass() {
      this.appLoading = true;
      this.classAdd.standard = this.standard;
      axios({
        method: "POST",
        url: "/class/add",
        data: this.classAdd,
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status) {
            this.msg = "Class Added Successully";
            this.showsnackbar = true;
            this.$router.push({ path: "/addClass" });
            this.classid = response.data.data.class._id;
            this.getData(this.classid);
          } else {
            this.msg = response.data.msg;
            this.showsnackbar = true;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    addSubject(cid) {
      this.appLoading = true;
      this.sub.classid = cid;
      axios({
        method: "POST",
        url: "/teacher/addsubject",
        data: this.sub,
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status) {
            this.msg = "Class Added Successully";
            this.showsnackbar = true;
            // this.classid = response.data.data.class._id;
            this.getGroupTeacher();
          } else {
            this.msg = response.data.msg;
            this.showsnackbar = true;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
  },
};
</script>
<style>
.dottedline {
  border: none;
  /* border-top: 1px dashed rgb(208, 208, 208); */
  color: #8f8f8f;
  /* text-align: center; */
  background-color: #8f8f8f;
  height: 1px;
  width: 100%;
}
</style>